import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../consts";

import { FirmwareVersionInput } from "../../../../components";
import { FWUNameContainer } from "../styled";

const firmwareInputConfig = [
  {
    id: "major",
    title: strCode.MAJOR_TITLE,
    min: 0,
    max: 99
  },
  {
    id: "minor",
    title: strCode.MINOR_TITLE,
    min: 0,
    max: 99
  },
  {
    id: "patch",
    title: strCode.PATCH_TITLE,
    min: 0,
    max: 99
  }
];

const defaultVersionValues = {
  major: null,
  minor: null,
  patch: null
};

const FWUName = ({ isLoading, fwuVersion, setFwuVersion }) => {
  const [versionValues, setVersionValues] = useState(defaultVersionValues);

  useEffect(() => {
    if (fwuVersion) {
      setVersionValues(fwuVersion.fwuVersion);
    }
  }, [fwuVersion?.fwuVersion]);

  const handleSetVersionValues = (newVersionValues) => {
    setVersionValues(newVersionValues);
    setFwuVersion((prev) => {
      return { ...prev, fwuVersion: newVersionValues };
    });
  };

  return (
    <FWUNameContainer width={"100%"}>
      <FirmwareVersionInput
        firmwareInputConfig={firmwareInputConfig}
        values={versionValues}
        setValues={handleSetVersionValues}
        disabled={isLoading}
        isSmall
      />
    </FWUNameContainer>
  );
};

FWUName.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  fwuVersion: PropTypes.shape({ fwuVersion: PropTypes.object }).isRequired,
  setFwuVersion: PropTypes.func.isRequired
};

export default FWUName;
